import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import UserHeaderTop from "./UserHeaderTop";
import UserHeaderMenu from "./UserHeaderMenu";
import UserFooter from "./UserFooter";
import styles from "./UserLayout.module.css";
import { TokenService } from "../../services/Api";

const UserLayout = () => {
  const navigate = useNavigate();

  // Check authentication on mount
  useEffect(() => {
    const isAuthenticated = TokenService.getToken();
    if (!isAuthenticated) {
      navigate("/login", { replace: true });
    }
  }, [navigate]);

  // Handle session expiry or logout events
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "accessToken" && !e.newValue) {
        navigate("/login", { replace: true });
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [navigate]);

  return (
    <div className={styles.layoutWrapper}>
      {/* Top Header - Blue with logo and icons */}
      <UserHeaderTop />

      {/* Menu Header - White with navigation menu */}
      <UserHeaderMenu />

      {/* Main Content Area */}
      <main className={styles.mainContent}>
        <div className={styles.contentWrapper}>
          <Outlet />
        </div>
      </main>

      {/* Footer */}
      <UserFooter />
    </div>
  );
};

export default UserLayout;
